module.exports = __webpack_public_path__ + "img/desktop.0721d7e0.svg";